import { render, staticRenderFns } from "./ImprimirSignosVitalesFecha.vue?vue&type=template&id=60a2331d&scoped=true"
import script from "./ImprimirSignosVitalesFecha.vue?vue&type=script&lang=js"
export * from "./ImprimirSignosVitalesFecha.vue?vue&type=script&lang=js"
import style0 from "./ImprimirSignosVitalesFecha.vue?vue&type=style&index=0&id=60a2331d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a2331d",
  null
  
)

export default component.exports